/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Many-to-many link between an organization and a property
 * @export
 * @interface LinkOrganizationProperty201Response
 */
export interface LinkOrganizationProperty201Response {
    /**
     * 
     * @type {number}
     * @memberof LinkOrganizationProperty201Response
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof LinkOrganizationProperty201Response
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof LinkOrganizationProperty201Response
     */
    organizationId: number;
    /**
     * 
     * @type {number}
     * @memberof LinkOrganizationProperty201Response
     */
    propertyId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkOrganizationProperty201Response
     */
    role?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinkOrganizationProperty201Response
     */
    notes?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof LinkOrganizationProperty201Response
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the LinkOrganizationProperty201Response interface.
 */
export function instanceOfLinkOrganizationProperty201Response(value: object): value is LinkOrganizationProperty201Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function LinkOrganizationProperty201ResponseFromJSON(json: any): LinkOrganizationProperty201Response {
    return LinkOrganizationProperty201ResponseFromJSONTyped(json, false);
}

export function LinkOrganizationProperty201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkOrganizationProperty201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'organizationId': json['organizationId'],
        'propertyId': json['propertyId'],
        'role': json['role'] == null ? undefined : json['role'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function LinkOrganizationProperty201ResponseToJSON(json: any): LinkOrganizationProperty201Response {
    return LinkOrganizationProperty201ResponseToJSONTyped(json, false);
}

export function LinkOrganizationProperty201ResponseToJSONTyped(value?: LinkOrganizationProperty201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'organizationId': value['organizationId'],
        'propertyId': value['propertyId'],
        'role': value['role'],
        'notes': value['notes'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

